// Copyright (c) 2016 Deere & Company

import {isAfterStartDate, isNotEmpty, isNotNull, isNumberInputValid} from '../../../shared/services/claim-shared-helper';

export const canShowAllSections = (claimNumber, isValidClaim) => isValidClaim || isNotEmpty(claimNumber);

const isNumberInputValidForNonTracked = (number, product) => product.isNonTracked ? isNumberInputValid(number) : true;

export const isValidClaim = (claim, product) => [
    isNotEmpty(claim.pin),
    isNotEmpty(claim.responsibleAccount.account),
    isNotEmpty(claim.referenceInfo.referenceNumber1),
    isNumberInputValidForNonTracked(claim.deliveryDate, product),
    isNumberInputValid(claim.returnDate),
    isNotEmpty(claim.failurePartNumber),
    isNotEmpty(claim.jdpReason.key),
    isNotEmpty(claim.jdpCustomerResolution.key),
    isNotEmpty(claim.jdpComments),
    isAfterStartDate(claim.returnDate, claim.deliveryDate)
].every(rule => rule);

export const mapFormValidation = (property, value) => {

    const map = {
        comments: isNotEmpty,
        customerResolution: isNotEmpty,
        deliveryDate: isNotNull,
        failurePartNumber: isNotEmpty,
        pin: isNotEmpty,
        reasonForReturn: isNotEmpty,
        responsibleAccount: isNotEmpty,
        returnDate: isNotNull,
        workOrderOne: isNotEmpty
    };

    return map[property](value);

};

export const checkClaimValidity = (currentPageValidity, validationFailed, selectedAction) => selectedAction === 'VALIDATE' ?
    !validationFailed && !currentPageValidity :
    false;



// WEBPACK FOOTER //
// ./src/claim/marketing/jdp/services/claim-validation-helper.js